import React, { FC } from 'react'
import {
  BaseGrid,
  BaseGridItem,
} from '@awaze/design-system.components.base-grid'
import { Headline } from '@awaze/design-system.components.text'

export interface PageTitleLowExperimentProps {
  title: string
}

export const PageTitleLowExperiment: FC<PageTitleLowExperimentProps> = ({
  title,
}) => {
  return (
    <BaseGrid flush>
      <BaseGridItem columns={[12]}>
        <Headline marginBottom={24} hasBorder as="h1" sizes={200}>
          {title}
        </Headline>
      </BaseGridItem>
    </BaseGrid>
  )
}
